import { TermsViewer } from "pages/terms/TermsViewer";

export const LocationTerms = () => {
    return <TermsViewer mode="location" />;
};
